<template>
    <div class="widget">
        <div class="user-photo border text-center" style="margin-top: 42px;">
            <img v-if="userAvatar" :src="userAvatar">

            <span class="user-photo-action" style="position: unset; margin-top: 20px;" id="pick-avatar"
                  v-text="translations.reupload"></span>

            <avatar-cropper @uploaded="handleUploaded"
                            trigger="#pick-avatar"
                            upload-url="/profile/avatar_upload"
                            :upload-headers="{'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN' : getCsrfToken()}"
                            :labels="{submit : translations.submit, cancel: translations.cancel}"/>
        </div>
    </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";

export default {
    components: {
        AvatarCropper
    },

    props: {
        translates: {
            type: String,
            required: true
        },
        avatar_url: {
            type: String,
            required: true
        },
        upload_url: {
            type: String,
            required: true
        }
    },

    data: function () {
        return {
            translations: {},
            userAvatar: null
        };
    },

    methods: {
        handleUploaded(resp) {
            this.userAvatar = resp.relative_url;
        },

        getCsrfToken() {
            return window.Laravel.csrfToken;
        }
    },

    mounted: function () {
        this.translations = JSON.parse(this.translates);
        this.userAvatar = this.avatar_url;
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/UserAvatar.vue